const defaultCardId = "9fb348bc-41a0-91ad-8a3e-818035c4e561";

export default function playerCardImageUrl(id: string | null | undefined) {
  return `https://media.valorant-api.com/playercards/${
    id ?? defaultCardId
  }/smallart.png`;
}
